module.exports = __webpack_public_path__ + "static/media/junte-pontos-mobile.4580c4d4.png";